import axios from 'axios';
import { getAccessToken } from '../../../selectors/travelUg/payments';
import {
    getTravellers,
    getCustomer,
    getIdDocumentIdValue,
    getIdUploadValue,
    getNationalityTypeValue,
} from '../../../selectors/travelUg/travelDetails';
import { setIdDocumentIdValue, setCustomerValue, updateTravellerValue } from '../../../actions/travelUg/travelDetails';

export const documentUploadChecksService = async (store, next, action) => {
    try {
        const state = store.getState();
        const idUpload = getIdUploadValue(state);
        const idDocumentId = getIdDocumentIdValue(state);
        const nationalityType = getNationalityTypeValue(state);
        const customer = getCustomer(state);
        const travellers = getTravellers(state);

        if (!idDocumentId?.value && nationalityType.value === 'Ugandan') {
            const resp = await upload(idUpload, state);

            store.dispatch(setIdDocumentIdValue(resp.data.document));
        }

        if (!customer.passportDocumentId?.value) {
            const resp = await upload(customer?.passportBiodata, state);

            store.dispatch(
                setCustomerValue({
                    ...customer,
                    passportDocumentId: { value: resp.data.document, error: null, status: null },
                })
            );
        }

        await Promise.allSettled(
            travellers.map(async (traveller) => {
                if (!traveller.passportDocumentId?.value && traveller.passportBiodata) {
                    try {
                        const resp = await upload(traveller.passportBiodata, state);
                        if (resp?.data?.document) {
                            store.dispatch(
                                updateTravellerValue(
                                    {
                                        ...traveller,
                                        passportDocumentId: resp.data.document,
                                    },
                                    traveller.travellerId
                                )
                            );
                        }
                    } catch (error) {
                        console.error(`traveller ${traveller.travellerId} error ${error}`);
                    }
                }
            })
        );
    } catch (e) {
        console.error(e);
        throw e;
    }
    return next(action);
};

const documentPayload = (document) => {
    const payload = {
        file: document?.value?.base64File || 'N/A',
        contentType: document?.value?.fileType || 'N/A',
        type: 'image',
        name: document?.value?.fileName || 'N/A',
    };

    return {
        ...payload,
    };
};

const upload = async (document, state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/travel-ug/upload-file';
        return await axios.post(url, documentPayload(document), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
